import React from 'react';
import { jcm } from 'utils';
import { Breakpoint } from 'types/utils';
import { ImagePlaceholder } from '@navi-toolbox/ui-components';

import { Styles as StylesAtDesktop } from './modal-layout-desktops.styles';
import { PictureSources } from '../photos-modal.types';
import { useTranslation } from 'react-i18next';

export const PictureThumbAtDesktop: React.FC<{
  isActive: boolean;
  thumbPicture: PictureSources;
  activeThumbRef: React.RefObject<HTMLButtonElement>;
  breakpoint: Breakpoint;
  setShowedPicture?: (value: PictureSources) => void;
}> = ({ isActive, thumbPicture, activeThumbRef, setShowedPicture }) => {
  const { t } = useTranslation();
  const onClickCb = React.useCallback(
    () => setShowedPicture?.(thumbPicture),
    [setShowedPicture, thumbPicture],
  );

  return (
    <button
      className={jcm({
        [StylesAtDesktop.thumb]: true,
        [StylesAtDesktop.thumbActive]: isActive,
      })}
      onClick={onClickCb}
      ref={isActive ? activeThumbRef : undefined}
      role="tab"
      aria-selected={isActive}
    >
      <ImagePlaceholder
        className={StylesAtDesktop.thumbImg}
        src={thumbPicture.urlThumb}
        loading="lazy"
        alt=""
        fallbackAlt={t('ui.image.alt')}
        fallbackWidth={48}
        fallbackHeight={48}
      />
    </button>
  );
};
